<script setup>
import { computed } from 'vue';

const props = defineProps({
  priority: { type: String, required: true },
  showLabel: { type: Boolean, default: false },
});

const PRIORITY_STYLES = {
  urgent: { icon: 'i-lucide-flame', class: 'text-n-ruby-11' },
  high: { icon: 'i-lucide-signal-high', class: 'text-n-amber-11' },
  medium: { icon: 'i-lucide-signal-medium', class: 'text-n-blue-11' },
  low: { icon: 'i-lucide-signal-low', class: 'text-n-slate-11' },
};

const style = computed(() => PRIORITY_STYLES[props.priority]);
</script>

<template>
  <span
    class="inline-flex items-center gap-1 text-xs whitespace-nowrap"
    :class="style.class"
    :title="$t(`CARDS.PRIORITY.${priority}`)"
  >
    <span class="flex-shrink-0 size-3.5" :class="style.icon" />
    <span v-if="showLabel">{{ $t(`CARDS.PRIORITY.${priority}`) }}</span>
  </span>
</template>
